import { FormControl, FormGroup } from '@angular/forms';
import { PointElement } from '../point-element';
import { PropertyMetadata } from '../../properties/property-types';
import { LevelDesignerElementBase } from '../element-base';
import { ParkingLevelElement } from '../parking/parkinglevel';
import { Lane } from '../access-control/lane';

export abstract class DeviceBase extends PointElement {

    layerIndex: number = 5;
    

    constructor(formGroup: FormGroup, svgPath: string) {
        super(formGroup, svgPath);
        
        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
        if (!formGroup.contains('DeviceId')) {
            formGroup.addControl('DeviceId', new FormControl(''));
        }
        if (!formGroup.contains('DisplayAngle')) {
            formGroup.addControl('DisplayAngle', new FormControl(0));
        }
        if (!formGroup.contains('SerialNumber')) {
            formGroup.addControl('SerialNumber', new FormControl(''));
        }
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            ...super.getPropertyMetadata(),
            {
                formControlName: 'Name',
                displayName: 'Device Name',
                inputType: { type: 'text' },
                order: 1,
                category: 'General'
            },
            
            {
                formControlName: 'SerialNumber',
                displayName: 'Serial Number',
                inputType: { type: 'text' },
                order: 5,
                category: 'General'
            },
           
        ];
    }

    public override updateForm(): void {
        super.updateForm();
        
        
        
    }

} 
